import { skipToken } from '@reduxjs/toolkit/query';
import { useFetchWebsiteIndexStatusQuery } from '../service';
import { WEBSITE_STATUS_POLLING_TIME_MS } from '../../settings';
import { useEffect, useState } from 'react';

export default function useWebsiteSetupStatus(websiteGuid: string | undefined) {
    const [shouldLongPoll, setShouldLongPoll] = useState<boolean>(true);

    const {
        data: websiteStatus,
        isLoading: isLoadingWebsiteStatus,
        isError: isWebsiteStatusError,
        refetch: refetchWebsiteStatus,
    } = useFetchWebsiteIndexStatusQuery(websiteGuid ? { guid: websiteGuid } : skipToken, {
        pollingInterval: shouldLongPoll ? WEBSITE_STATUS_POLLING_TIME_MS : 0,
    });

    const isImportingSitemaps = !!websiteStatus && websiteStatus.status === 'importing_sitemaps';

    useEffect(() => {
        if (!shouldLongPoll && isImportingSitemaps) {
            setShouldLongPoll(true);
        }
        if (shouldLongPoll && !isImportingSitemaps) {
            setShouldLongPoll(false);
        }
    }, [isImportingSitemaps, shouldLongPoll]);

    return {
        websiteStatus,
        isLoadingWebsiteStatus,
        isWebsiteStatusError,
        refetchWebsiteStatus,
    };
}
